import { Circle, GoogleMap, MarkerClusterer } from "@react-google-maps/api";
import { MapMarker } from "./map-marker.js";
import React from "react";
const _Map = ({ defaultCenter, defaultZoom = 10, point, radius = 25000, retailers = [], }) => {
    const containerStyle = { minHeight: "48vh", height: `100%` };
    const position = {
        lat: point?.lat ?? defaultCenter.lat,
        lng: point?.lng ?? defaultCenter.lng,
    };
    return (React.createElement(GoogleMap, { center: position, options: {
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
        }, mapContainerStyle: containerStyle, zoom: defaultZoom },
        React.createElement(Circle, { center: position, options: {
                fillColor: "#FF0000",
                fillOpacity: 0.05,
                strokeColor: "#FF0000",
                strokeOpacity: 0.5,
                strokeWeight: 2,
            }, radius: radius * 1000, visible: true }),
        React.createElement(MarkerClusterer, { averageCenter: true, enableRetinaIcons: true, gridSize: 60 }, (clusterer) => (React.createElement(React.Fragment, null, retailers.map((retailer) => (React.createElement(MapMarker, { clusterer: clusterer, key: `marker-${retailer._id}`, retailer: retailer }))))))));
};
export const Map = React.memo(_Map);
//# sourceMappingURL=map.js.map